import React from 'react';
import dateFormat, { masks } from "dateformat";
class InquiryMasterDetailView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const renderPor = () => {
      if (this.props.data.data.POR=="") {
        return "-";
      } else {
        return (
          "("+
          this.props.data.data.POR_NAME
          +")"
          
        );
      }
    }
    const renderPol = () => {
      if (this.props.data.data.POL=="") {
        return "-";
      } else {
        return (
          "("+
          this.props.data.data.POL_NAME
          +")"
          
        );
      }
    }
    const renderPod = () => {
      if (this.props.data.data.POD=="") {
        return "-";
      } else {
        return (
          "("+
          this.props.data.data.POD_NAME
          +")"
          
        );
      }
    }
    const renderDel = () => {
      if (this.props.data.data.DEL=="") {
        return "-";
      } else {
        return (
          "("+
          this.props.data.data.DEL_NAME
          +")"
          
        );
      }
    }

    return (
      <table border="1" width="100%">
      <tr className="box">
        <td width="80" align="center">
        Request by
        </td>
        <td width="80" align="center">
        Received by
        </td>
        <td width="80" align="center">
        Last Update By
        </td>
        <td width="80" align="center">
          POR
        </td>

        <td width="80" align="center">
          POL
        </td>

        <td width="80" align="center">
        DESTINATION
        </td>

        <td width="80" align="center">
        POD
        </td>

        <td width="80" align="center">DEL</td>
        <td align="left">REMARK</td>
      </tr>
      <tr>
        <td align="center">{this.props.data.data.USERNAME}</td>
        <td align="center">{this.props.data.data.REC_NAME}</td>
        <td align="center">{this.props.data.data.LASTUPDATE_NAME}</td>
        <td width="40" align="center">
          {this.props.data.data.POR == "" ? "-" : this.props.data.data.POR}
        </td>
        <td width="40" align="center">
          {this.props.data.data.POL == "" ? "-" : this.props.data.data.POL}
        </td>
        <td width="40" align="center">
          {this.props.data.data.DESTINATION_NAME == "" ? "-" : this.props.data.data.DESTINATION_NAME}
        </td>
        <td width="40" align="center">
          {this.props.data.data.POD == "" ? "-" : this.props.data.data.POD}
        </td>
        <td width="40" align="center">
          {this.props.data.data.DEL == "" ? "-" : this.props.data.data.DEL}
        </td>
        <td align="left">
          {this.props.data.data.REMARK == "" ? "-" : this.props.data.data.REMARK}
        </td>
      </tr>
    </table>
    // <div>
    //   <p className='col1'>Request by:</p><p className='col2'>{this.props.data.data.USERNAME}</p>
    //   <p className='col1'>Received by:</p><p className='col2'>{this.props.data.data.REC_NAME}</p>
    //   <p className='col1'>Last Update By:</p><p className='col2'>{this.props.data.data.LASTUPDATE_NAME}</p>
    //   <p className='col1'>POR:</p><p className='col2'>{this.props.data.data.POR}</p>
    //   <p className='col1'>POL:</p><p className='col2'>{this.props.data.data.POL}</p>
    //   <p className='col1'>DESTINATION:</p><p className='col2'>{this.props.data.data.DESTINATION_NAME}</p>
    //   <p className='col1'>POD:</p><p className='col2'>{this.props.data.data.POD}</p>
    //   <p className='col1'>DEL:</p><p className='col2'>{this.props.data.data.DEL}</p>
    //   <p className='col1'>REMARK:</p><p className='col2'>{this.props.data.data.REMARK}</p>
    //   </div>
    );
  }
}

export default InquiryMasterDetailView;
